module.exports = __webpack_public_path__ + "static/demo-preview-web-b3934c2f3372c796a4d5f6e41152e9cd.png";